// ** React Imports
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

const FooterPage = () => {
    return (
        <footer className="footer-section py-4 mt-auto" style={{
            backgroundColor: '#f8f9fa',
            borderTop: '1px solid #e9ecef'
        }}>
            <Container>
                <Row className="justify-content-center">
                    <Col xs="12" className="text-center mb-3">
                        <p className="mb-1" style={{ 
                            fontSize: '0.95rem',
                            color: '#333',
                            fontWeight: '500'
                        }}>
                            © 2025 - UN Global Compact Network South Africa. All Rights Reserved.
                        </p>
                        <p className="mb-3" style={{ 
                            fontSize: '0.9rem',
                            color: '#666'
                        }}>
                            In partnership with UN Global Compact Network Malaysia & Brunei. Sponsor of the Hub development - The Bidvest Group.
                        </p>
                    </Col>
                    <Col xs="12" className="text-center">
                        <p className="mb-0" style={{ 
                            fontSize: '0.85rem',
                            color: '#888',
                            borderTop: '1px solid #eee',
                            paddingTop: '1rem'
                        }}>
                            Developed by <span style={{ fontWeight: '500' }}>Segwitz</span> - 
                            Maintained by <Link 
                                to="https://creativebox.world" 
                                style={{ 
                                    color: '#0066cc',
                                    textDecoration: 'none'
                                }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                CreativeBox
                            </Link>
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default FooterPage;
